export default { sha: '413966b3f9cd5cf83950bb880b71067f9677703f', buildNumber: 'undefined' }
